import { SUNDRY_TEMPLATE } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeSundryTemplate as deserializer } from "lib/serializers/sundryTemplates";

export default offlineCrudReducer(SUNDRY_TEMPLATE, {
  deserializer,
});
